/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CancelAtPeriodEndResponseFromJSON, CheckoutSessionResponseFromJSON, CheckoutSessionStatusResponseFromJSON, DowngradeSubscriptionRequestToJSON, DowngradeSubscriptionResponseFromJSON, PortalRequestToJSON, ReactivateResponseFromJSON, ReleaseDowngradeResponseFromJSON, SrcApiSubscriptionsCheckoutRequestToJSON, SubscriptionResponseFromJSON, UpgradeSubscriptionRequestToJSON, UpgradeSubscriptionResponseFromJSON } from '../models/index';
import * as runtime from '../runtime';
/**
 *
 */
export class SubscriptionsApi extends runtime.BaseAPI {
    /**
     * Schedule cancellation at the end of the current, already-paid period.  PK\'s own billing model (2026-07-24 10:29): NEVER ends the subscription outright — flips Stripe\'s own ``cancel_at_period_end`` flag only, so the paid tier/quota stay untouched until the real Stripe period end (see ``src.services.subscription_cancellation_service`` for the full contract, including the P0 incident this closes). Idempotent — a retry of the same click returns ``\"already_processed\"``, never a second Stripe call. Reversed by ``POST /subscriptions/reactivate``.  Returns:     CancelAtPeriodEndResponse: New cancellation flag + current period end.
     * Cancel At Period End Endpoint
     */
    async cancelAtPeriodEndEndpointV1SubscriptionsCancelAtPeriodEndPostRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/subscriptions/cancel-at-period-end`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => CancelAtPeriodEndResponseFromJSON(jsonValue));
    }
    /**
     * Schedule cancellation at the end of the current, already-paid period.  PK\'s own billing model (2026-07-24 10:29): NEVER ends the subscription outright — flips Stripe\'s own ``cancel_at_period_end`` flag only, so the paid tier/quota stay untouched until the real Stripe period end (see ``src.services.subscription_cancellation_service`` for the full contract, including the P0 incident this closes). Idempotent — a retry of the same click returns ``\"already_processed\"``, never a second Stripe call. Reversed by ``POST /subscriptions/reactivate``.  Returns:     CancelAtPeriodEndResponse: New cancellation flag + current period end.
     * Cancel At Period End Endpoint
     */
    async cancelAtPeriodEndEndpointV1SubscriptionsCancelAtPeriodEndPost(initOverrides) {
        const response = await this.cancelAtPeriodEndEndpointV1SubscriptionsCancelAtPeriodEndPostRaw(initOverrides);
        return await response.value();
    }
    /**
     * Create a checkout session for subscription upgrade.  Every provider (Stripe, PayPal, Mercado Pago) returns a ``url`` — the hosted checkout page the frontend redirects the browser to; see ``CheckoutSessionResponse``.  Args:     request: Checkout request with tier, URLs, and optional provider/currency.     http_request: The raw FastAPI request — used only to resolve the caller\'s         geo-located country (meta-pricing currency choice, PK 2026-07-13) for         server-side currency validation; never trust a client-supplied country.  Returns:     CheckoutSessionResponse: the provider\'s hosted checkout ``url``.  Raises:     HTTPException: 400 if ``request.withdrawal_waiver_at`` is missing,         blank, or unparseable (``enforce_withdrawal_waiver_consent`` —         V2M-DEV-021: server-side consent is mandatory, never inferred).
     * Create Checkout Session
     */
    async createCheckoutSessionV1SubscriptionsCheckoutPostRaw(requestParameters, initOverrides) {
        if (requestParameters['srcApiSubscriptionsCheckoutRequest'] == null) {
            throw new runtime.RequiredError('srcApiSubscriptionsCheckoutRequest', 'Required parameter "srcApiSubscriptionsCheckoutRequest" was null or undefined when calling createCheckoutSessionV1SubscriptionsCheckoutPost().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/subscriptions/checkout`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SrcApiSubscriptionsCheckoutRequestToJSON(requestParameters['srcApiSubscriptionsCheckoutRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => CheckoutSessionResponseFromJSON(jsonValue));
    }
    /**
     * Create a checkout session for subscription upgrade.  Every provider (Stripe, PayPal, Mercado Pago) returns a ``url`` — the hosted checkout page the frontend redirects the browser to; see ``CheckoutSessionResponse``.  Args:     request: Checkout request with tier, URLs, and optional provider/currency.     http_request: The raw FastAPI request — used only to resolve the caller\'s         geo-located country (meta-pricing currency choice, PK 2026-07-13) for         server-side currency validation; never trust a client-supplied country.  Returns:     CheckoutSessionResponse: the provider\'s hosted checkout ``url``.  Raises:     HTTPException: 400 if ``request.withdrawal_waiver_at`` is missing,         blank, or unparseable (``enforce_withdrawal_waiver_consent`` —         V2M-DEV-021: server-side consent is mandatory, never inferred).
     * Create Checkout Session
     */
    async createCheckoutSessionV1SubscriptionsCheckoutPost(requestParameters, initOverrides) {
        const response = await this.createCheckoutSessionV1SubscriptionsCheckoutPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a Stripe customer portal session for managing subscription.  Args:     request: Portal request with return URL  Returns:     dict: Customer portal URL
     * Create Customer Portal Session
     */
    async createCustomerPortalSessionV1SubscriptionsPortalPostRaw(requestParameters, initOverrides) {
        if (requestParameters['portalRequest'] == null) {
            throw new runtime.RequiredError('portalRequest', 'Required parameter "portalRequest" was null or undefined when calling createCustomerPortalSessionV1SubscriptionsPortalPost().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/subscriptions/portal`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PortalRequestToJSON(requestParameters['portalRequest']),
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Create a Stripe customer portal session for managing subscription.  Args:     request: Portal request with return URL  Returns:     dict: Customer portal URL
     * Create Customer Portal Session
     */
    async createCustomerPortalSessionV1SubscriptionsPortalPost(requestParameters, initOverrides) {
        const response = await this.createCustomerPortalSessionV1SubscriptionsPortalPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Schedule a downgrade to a lower tier, effective at the end of the current period.  PK\'s own billing model (2026-07-24 10:29, wariant A): the current, already-paid period completes at today\'s price — no refund — and only the NEXT cycle starts at the lower tier. Implemented via a Stripe Subscription Schedule on the customer\'s existing subscription — see ``src.services.subscription_downgrade_service`` for the full contract. Reversible via ``POST /subscriptions/downgrade/cancel`` before it takes effect.  Args:     request: Downgrade request with the target tier.  Returns:     DowngradeSubscriptionResponse: Current tier, pending target tier, and     when it takes effect.
     * Downgrade Subscription Endpoint
     */
    async downgradeSubscriptionEndpointV1SubscriptionsDowngradePostRaw(requestParameters, initOverrides) {
        if (requestParameters['downgradeSubscriptionRequest'] == null) {
            throw new runtime.RequiredError('downgradeSubscriptionRequest', 'Required parameter "downgradeSubscriptionRequest" was null or undefined when calling downgradeSubscriptionEndpointV1SubscriptionsDowngradePost().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/subscriptions/downgrade`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DowngradeSubscriptionRequestToJSON(requestParameters['downgradeSubscriptionRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => DowngradeSubscriptionResponseFromJSON(jsonValue));
    }
    /**
     * Schedule a downgrade to a lower tier, effective at the end of the current period.  PK\'s own billing model (2026-07-24 10:29, wariant A): the current, already-paid period completes at today\'s price — no refund — and only the NEXT cycle starts at the lower tier. Implemented via a Stripe Subscription Schedule on the customer\'s existing subscription — see ``src.services.subscription_downgrade_service`` for the full contract. Reversible via ``POST /subscriptions/downgrade/cancel`` before it takes effect.  Args:     request: Downgrade request with the target tier.  Returns:     DowngradeSubscriptionResponse: Current tier, pending target tier, and     when it takes effect.
     * Downgrade Subscription Endpoint
     */
    async downgradeSubscriptionEndpointV1SubscriptionsDowngradePost(requestParameters, initOverrides) {
        const response = await this.downgradeSubscriptionEndpointV1SubscriptionsDowngradePostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Resolve what happened to a Stripe Checkout session after the redirect back.  Server-side probe backing the return page: Stripe redirects the browser back from its hosted Checkout page to the session\'s ``success_url`` with ``?session_id={CHECKOUT_SESSION_ID}`` substituted — the frontend calls this endpoint rather than trusting the URL alone, since secret-key operations must never happen in the browser.  Args:     session_id: The Stripe Checkout Session id from the redirect\'s         ``session_id`` query param.     user: The authenticated caller — checked against the session\'s own         ``metadata.firebase_uid`` below so one logged-in user cannot probe         another customer\'s session id.  Returns:     CheckoutSessionStatusResponse: Stripe\'s own ``status``/``payment_status``     plus the derived ``pending`` flag.  Raises:     HTTPException: 404 if no session exists for ``session_id``, OR if it         exists but belongs to a different user (never a distinguishing         403 — a mismatch must not confirm the session\'s existence to a         caller who doesn\'t own it).
     * Get Checkout Session Status
     */
    async getCheckoutSessionStatusV1SubscriptionsCheckoutSessionIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError('sessionId', 'Required parameter "sessionId" was null or undefined when calling getCheckoutSessionStatusV1SubscriptionsCheckoutSessionIdGet().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/subscriptions/checkout/{session_id}`;
        urlPath = urlPath.replace(`{${"session_id"}}`, encodeURIComponent(String(requestParameters['sessionId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => CheckoutSessionStatusResponseFromJSON(jsonValue));
    }
    /**
     * Resolve what happened to a Stripe Checkout session after the redirect back.  Server-side probe backing the return page: Stripe redirects the browser back from its hosted Checkout page to the session\'s ``success_url`` with ``?session_id={CHECKOUT_SESSION_ID}`` substituted — the frontend calls this endpoint rather than trusting the URL alone, since secret-key operations must never happen in the browser.  Args:     session_id: The Stripe Checkout Session id from the redirect\'s         ``session_id`` query param.     user: The authenticated caller — checked against the session\'s own         ``metadata.firebase_uid`` below so one logged-in user cannot probe         another customer\'s session id.  Returns:     CheckoutSessionStatusResponse: Stripe\'s own ``status``/``payment_status``     plus the derived ``pending`` flag.  Raises:     HTTPException: 404 if no session exists for ``session_id``, OR if it         exists but belongs to a different user (never a distinguishing         403 — a mismatch must not confirm the session\'s existence to a         caller who doesn\'t own it).
     * Get Checkout Session Status
     */
    async getCheckoutSessionStatusV1SubscriptionsCheckoutSessionIdGet(requestParameters, initOverrides) {
        const response = await this.getCheckoutSessionStatusV1SubscriptionsCheckoutSessionIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get current user\'s subscription information.  Returns:     dict: Subscription details
     * Get Subscription
     */
    async getSubscriptionV1SubscriptionsGetRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/subscriptions`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionResponseFromJSON(jsonValue));
    }
    /**
     * Get current user\'s subscription information.  Returns:     dict: Subscription details
     * Get Subscription
     */
    async getSubscriptionV1SubscriptionsGet(initOverrides) {
        const response = await this.getSubscriptionV1SubscriptionsGetRaw(initOverrides);
        return await response.value();
    }
    /**
     * Bridge PayPal\'s Subscriptions v1 \"approve\" redirect back to the frontend.  Root-cause fix (V2M-227 follow-up, 2026-07-09): PayPal redirects the browser here (``return_url``) once the customer approves a subscription, appending ``subscription_id``/``ba_token`` — this route previously did not exist, so the customer landed on raw ``{\"detail\":\"Not Found\"}`` JSON right after approving payment.  Unauthenticated by necessity (PayPal carries no Firebase token) — see ``PayPalReturnService.resolve_redirect_url`` for the open-redirect guard (``success_url``\'s origin must be on ``settings.allowed_origins_list``) and the multi-brand-safe fallback (``settings.brand.dashboard_url``, never a hardcoded domain) when no ``success_url`` was given.  Args:     subscription_id: PayPal Subscription id PayPal appended on approval.     ba_token: PayPal billing-agreement token PayPal appended; accepted for         contract completeness, not otherwise used — subscription state is         read from our own Firestore sync, not PayPal\'s API.     success_url: The frontend success page the checkout flow originally         targeted, if the caller embedded one in the return_url given to         PayPal.     db: Firestore client.  Returns:     RedirectResponse: 302 to the resolved frontend URL.
     * Paypal Return
     */
    async paypalReturnV1SubscriptionsPaypalReturnGetRaw(requestParameters, initOverrides) {
        if (requestParameters['subscriptionId'] == null) {
            throw new runtime.RequiredError('subscriptionId', 'Required parameter "subscriptionId" was null or undefined when calling paypalReturnV1SubscriptionsPaypalReturnGet().');
        }
        const queryParameters = {};
        if (requestParameters['baToken'] != null) {
            queryParameters['ba_token'] = requestParameters['baToken'];
        }
        if (requestParameters['subscriptionId'] != null) {
            queryParameters['subscription_id'] = requestParameters['subscriptionId'];
        }
        if (requestParameters['successUrl'] != null) {
            queryParameters['success_url'] = requestParameters['successUrl'];
        }
        const headerParameters = {};
        let urlPath = `/v1/subscriptions/paypal/return`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Bridge PayPal\'s Subscriptions v1 \"approve\" redirect back to the frontend.  Root-cause fix (V2M-227 follow-up, 2026-07-09): PayPal redirects the browser here (``return_url``) once the customer approves a subscription, appending ``subscription_id``/``ba_token`` — this route previously did not exist, so the customer landed on raw ``{\"detail\":\"Not Found\"}`` JSON right after approving payment.  Unauthenticated by necessity (PayPal carries no Firebase token) — see ``PayPalReturnService.resolve_redirect_url`` for the open-redirect guard (``success_url``\'s origin must be on ``settings.allowed_origins_list``) and the multi-brand-safe fallback (``settings.brand.dashboard_url``, never a hardcoded domain) when no ``success_url`` was given.  Args:     subscription_id: PayPal Subscription id PayPal appended on approval.     ba_token: PayPal billing-agreement token PayPal appended; accepted for         contract completeness, not otherwise used — subscription state is         read from our own Firestore sync, not PayPal\'s API.     success_url: The frontend success page the checkout flow originally         targeted, if the caller embedded one in the return_url given to         PayPal.     db: Firestore client.  Returns:     RedirectResponse: 302 to the resolved frontend URL.
     * Paypal Return
     */
    async paypalReturnV1SubscriptionsPaypalReturnGet(requestParameters, initOverrides) {
        const response = await this.paypalReturnV1SubscriptionsPaypalReturnGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Handle PayPal webhook events for subscription lifecycle (V2M-227).  Mirrors ``/webhooks/stripe``\'s shape: raw body + PayPal transmission headers -> ``PayPalAdapter.verify_and_parse_webhook`` (self-verify PKI) -> idempotency claim -> event routing -> Firestore sync (``PayPalWebhookService``). The verified provider\'s client is handed to ``handle_event`` so subscription-lifecycle handlers can re-fetch live truth from PayPal before projecting state (V2M-227 fala 2 out-of-order convergence fix — mirrors Stripe\'s sync-from-truth). A rejected signature/payload returns 400 (stop PayPal\'s retries — the payload will never verify on retry); once verified, this always returns 200 — processing failures are captured in the dead letter queue and replayed via the same admin endpoint Stripe uses, since re-driving PayPal\'s own retry schedule is pointless for an error on our side.  Handles: - BILLING.SUBSCRIPTION.ACTIVATED - BILLING.SUBSCRIPTION.CANCELLED / SUSPENDED / EXPIRED - PAYMENT.SALE.COMPLETED  Returns:     dict: Webhook processing result.
     * Paypal Webhook
     */
    async paypalWebhookV1SubscriptionsWebhooksPaypalPostRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        let urlPath = `/v1/subscriptions/webhooks/paypal`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Handle PayPal webhook events for subscription lifecycle (V2M-227).  Mirrors ``/webhooks/stripe``\'s shape: raw body + PayPal transmission headers -> ``PayPalAdapter.verify_and_parse_webhook`` (self-verify PKI) -> idempotency claim -> event routing -> Firestore sync (``PayPalWebhookService``). The verified provider\'s client is handed to ``handle_event`` so subscription-lifecycle handlers can re-fetch live truth from PayPal before projecting state (V2M-227 fala 2 out-of-order convergence fix — mirrors Stripe\'s sync-from-truth). A rejected signature/payload returns 400 (stop PayPal\'s retries — the payload will never verify on retry); once verified, this always returns 200 — processing failures are captured in the dead letter queue and replayed via the same admin endpoint Stripe uses, since re-driving PayPal\'s own retry schedule is pointless for an error on our side.  Handles: - BILLING.SUBSCRIPTION.ACTIVATED - BILLING.SUBSCRIPTION.CANCELLED / SUSPENDED / EXPIRED - PAYMENT.SALE.COMPLETED  Returns:     dict: Webhook processing result.
     * Paypal Webhook
     */
    async paypalWebhookV1SubscriptionsWebhooksPaypalPost(initOverrides) {
        const response = await this.paypalWebhookV1SubscriptionsWebhooksPaypalPostRaw(initOverrides);
        return await response.value();
    }
    /**
     * Undo a pending cancel-at-period-end — the customer changed their mind.  Standard self-service undo, mirrors ``POST /subscriptions/cancel-at-period- end``. Idempotent — a user who isn\'t currently flagged gets ``\"already_processed\"``, never a Stripe call. A subscription that has already fully ended (period end already passed) cannot be reactivated — the customer must check out again.  Returns:     ReactivateResponse: New cancellation flag + current period end.
     * Reactivate Endpoint
     */
    async reactivateEndpointV1SubscriptionsReactivatePostRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/subscriptions/reactivate`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ReactivateResponseFromJSON(jsonValue));
    }
    /**
     * Undo a pending cancel-at-period-end — the customer changed their mind.  Standard self-service undo, mirrors ``POST /subscriptions/cancel-at-period- end``. Idempotent — a user who isn\'t currently flagged gets ``\"already_processed\"``, never a Stripe call. A subscription that has already fully ended (period end already passed) cannot be reactivated — the customer must check out again.  Returns:     ReactivateResponse: New cancellation flag + current period end.
     * Reactivate Endpoint
     */
    async reactivateEndpointV1SubscriptionsReactivatePost(initOverrides) {
        const response = await this.reactivateEndpointV1SubscriptionsReactivatePostRaw(initOverrides);
        return await response.value();
    }
    /**
     * Cancel a pending downgrade — release the Stripe Schedule.  Idempotent — a user with no pending downgrade gets ``\"already_released\"``, never a Stripe call.  Returns:     ReleaseDowngradeResponse: Release status.
     * Release Downgrade Endpoint
     */
    async releaseDowngradeEndpointV1SubscriptionsDowngradeCancelPostRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/subscriptions/downgrade/cancel`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ReleaseDowngradeResponseFromJSON(jsonValue));
    }
    /**
     * Cancel a pending downgrade — release the Stripe Schedule.  Idempotent — a user with no pending downgrade gets ``\"already_released\"``, never a Stripe call.  Returns:     ReleaseDowngradeResponse: Release status.
     * Release Downgrade Endpoint
     */
    async releaseDowngradeEndpointV1SubscriptionsDowngradeCancelPost(initOverrides) {
        const response = await this.releaseDowngradeEndpointV1SubscriptionsDowngradeCancelPostRaw(initOverrides);
        return await response.value();
    }
    /**
     * Replay a failed webhook event from the dead letter queue.  Admin-only endpoint for reprocessing failed Stripe webhook events.  Args:     event_id: Stripe event ID to replay     _admin: Admin user info (enforces admin role)  Returns:     dict: Replay result
     * Replay Dead Letter
     */
    async replayDeadLetterV1SubscriptionsWebhooksReplayEventIdPostRaw(requestParameters, initOverrides) {
        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError('eventId', 'Required parameter "eventId" was null or undefined when calling replayDeadLetterV1SubscriptionsWebhooksReplayEventIdPost().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/subscriptions/webhooks/replay/{event_id}`;
        urlPath = urlPath.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters['eventId'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Replay a failed webhook event from the dead letter queue.  Admin-only endpoint for reprocessing failed Stripe webhook events.  Args:     event_id: Stripe event ID to replay     _admin: Admin user info (enforces admin role)  Returns:     dict: Replay result
     * Replay Dead Letter
     */
    async replayDeadLetterV1SubscriptionsWebhooksReplayEventIdPost(requestParameters, initOverrides) {
        const response = await this.replayDeadLetterV1SubscriptionsWebhooksReplayEventIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Handle Stripe webhook events.  This endpoint receives webhook events from Stripe for subscription lifecycle: - checkout.session.completed - customer.subscription.created - customer.subscription.updated - customer.subscription.deleted  Returns:     dict: Webhook processing result
     * Stripe Webhook
     */
    async stripeWebhookV1SubscriptionsWebhooksStripePostRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters['stripeSignature'] != null) {
            headerParameters['stripe-signature'] = String(requestParameters['stripeSignature']);
        }
        let urlPath = `/v1/subscriptions/webhooks/stripe`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Handle Stripe webhook events.  This endpoint receives webhook events from Stripe for subscription lifecycle: - checkout.session.completed - customer.subscription.created - customer.subscription.updated - customer.subscription.deleted  Returns:     dict: Webhook processing result
     * Stripe Webhook
     */
    async stripeWebhookV1SubscriptionsWebhooksStripePost(requestParameters = {}, initOverrides) {
        const response = await this.stripeWebhookV1SubscriptionsWebhooksStripePostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Upgrade to a higher tier — full new-tier price charged immediately.  PK\'s own billing model (2026-07-24): not Stripe proration, not the billing portal\'s ``subscription_update`` (deliberately disabled — see ``scripts/configure_billing_portal.py``). This is the ONLY sanctioned path for a tier change on an existing subscription. See ``src.services.subscription_upgrade_service`` for the full contract (idempotency, credit gift, anchor reset).  A user without an existing subscription should use ``POST /checkout`` instead — this endpoint requires a live, collectible subscription to upgrade (see 409 contract on ``POST /checkout`` for how a repeat-checkout attempt is routed here).  Args:     request: Upgrade request with the target tier.  Returns:     UpgradeSubscriptionResponse: New tier + bonus credits granted.
     * Upgrade Subscription Endpoint
     */
    async upgradeSubscriptionEndpointV1SubscriptionsUpgradePostRaw(requestParameters, initOverrides) {
        if (requestParameters['upgradeSubscriptionRequest'] == null) {
            throw new runtime.RequiredError('upgradeSubscriptionRequest', 'Required parameter "upgradeSubscriptionRequest" was null or undefined when calling upgradeSubscriptionEndpointV1SubscriptionsUpgradePost().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/subscriptions/upgrade`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpgradeSubscriptionRequestToJSON(requestParameters['upgradeSubscriptionRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => UpgradeSubscriptionResponseFromJSON(jsonValue));
    }
    /**
     * Upgrade to a higher tier — full new-tier price charged immediately.  PK\'s own billing model (2026-07-24): not Stripe proration, not the billing portal\'s ``subscription_update`` (deliberately disabled — see ``scripts/configure_billing_portal.py``). This is the ONLY sanctioned path for a tier change on an existing subscription. See ``src.services.subscription_upgrade_service`` for the full contract (idempotency, credit gift, anchor reset).  A user without an existing subscription should use ``POST /checkout`` instead — this endpoint requires a live, collectible subscription to upgrade (see 409 contract on ``POST /checkout`` for how a repeat-checkout attempt is routed here).  Args:     request: Upgrade request with the target tier.  Returns:     UpgradeSubscriptionResponse: New tier + bonus credits granted.
     * Upgrade Subscription Endpoint
     */
    async upgradeSubscriptionEndpointV1SubscriptionsUpgradePost(requestParameters, initOverrides) {
        const response = await this.upgradeSubscriptionEndpointV1SubscriptionsUpgradePostRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
